export const mutations = {
  addPurchaseorderItems(state) {
    state.purchase_order_items.push({
      product_id: "",
      product_measurement: "",
      qty: "",
      unit_price: "",
      total_price: "",
      remarks: ""
    });
  },

  STORE_PURCHASEORDERS(state, purchaseorders) {
    state.purchaseorders = purchaseorders;
  },


  STORE_PURCHASEORDER_ITEMS(state, purchase_order_item){
    state.purchase_order_item = purchase_order_item
  },


  STORE_PURCHASEORDER_GOODS(state, purchaseorder){
    state.purchaseorder = purchaseorder
  },

  

  STORE_PURCHASEORDER_UPDATE(state, id){
    let Purchaseorderitem = state.purchaseorders.find(function(purchaseorder) {
      return purchaseorder.id === id
    })
    state.systemPurchaseorderItem = Purchaseorderitem;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/purchaseorders/mutations.js